<template>
  <modal name="outdated-listing" width="400">
    <div class="modal-content details-form-container outdated-modal">
      <div class="d-flex align-items-center pb-3">
        <a :href="'/agents/' + marketer.slug">
          <img
            class="details-agent-img"
            :src="marketer.profile_picture.url"
            :alt="marketer.name"
          />
        </a>
        <div class="d-flex flex-column">
          <a :href="'/agents/' + marketer.slug" class="normal">
            <div class="details-agent-name text-capitalize">
              {{ marketer.name.toLowerCase() }} {{ marketer.chinese_name }}
            </div>
          </a>
          <div class="details-agent-post pt-2">
            Hi, sorry the listing is <span style="color: red; font-weight: bold;">{{ltype == 'rent' ? 'RENTED' : 'SOLD' }}</span>
          </div>
          <div class="mt-2">please call or whatsapp me if you are looking to buy , sell or rent a property ,thank you.</div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center py-4">
        <div class="d-flex flex-column align-items-center w-25">
          <button data-toggle="modal" data-target="#details-contact-form">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="50" height="50" rx="25" fill="#0F0D0D"></rect>
              <path
                d="M25 14C21.9624 14 19.5 16.4624 19.5 19.5C19.5 22.5377 21.9624 25 25 25C28.0377 25 30.5 22.5377 30.5 19.5C30.5 16.4624 28.0377 14 25 14Z"
                fill="#515151"
              ></path>
              <path
                d="M16.3375 26.1C15.7177 26.1 15.1232 26.3462 14.6848 26.7844C14.2465 27.2227 14.0001 27.8171 14 28.437V28.85C14 30.9153 15.0681 32.4619 16.706 33.459C18.3175 34.4397 20.4823 34.9 22.8 34.9V27.2C22.8 26.7991 22.9073 26.4234 23.0942 26.1H16.3375Z"
                fill="#515151"
              ></path>
              <path
                d="M23.9 27.75C23.9 27.3124 24.0738 26.8927 24.3833 26.5833C24.6927 26.2738 25.1124 26.1 25.55 26.1H34.35C34.7876 26.1 35.2073 26.2738 35.5167 26.5833C35.8262 26.8927 36 27.3124 36 27.75V28.1845L29.95 30.9939L23.9 28.1845V27.75Z"
                fill="#515151"
              ></path>
              <path
                d="M30.1816 32.0989L36 29.3972V34.35C36 34.7876 35.8262 35.2073 35.5167 35.5167C35.2073 35.8262 34.7876 36 34.35 36H25.55C25.1124 36 24.6927 35.8262 24.3833 35.5167C24.0738 35.2073 23.9 34.7876 23.9 34.35V29.3972L29.7184 32.0989C29.791 32.1325 29.87 32.15 29.95 32.15C30.03 32.15 30.109 32.1325 30.1816 32.0989Z"
                fill="#515151"
              ></path>
            </svg>
          </button>
          <div class="pt-2">Message</div>
        </div>
        <div class="d-flex flex-column align-items-center w-25">
          <a href="tel:+60134817777"
            ><svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="50" height="50" rx="25" fill="#0F0D0D"></rect>
              <path
                d="M26.1 20.6C26.9752 20.6 27.8146 20.9477 28.4334 21.5665C29.0523 22.1854 29.4 23.0248 29.4 23.9C29.4 24.1917 29.5159 24.4715 29.7222 24.6778C29.9285 24.8841 30.2083 25 30.5 25C30.7917 25 31.0715 24.8841 31.2778 24.6778C31.4841 24.4715 31.6 24.1917 31.6 23.9C31.6 22.4413 31.0205 21.0424 29.9891 20.0109C28.9576 18.9795 27.5587 18.4 26.1 18.4C25.8083 18.4 25.5285 18.5159 25.3222 18.7222C25.1159 18.9285 25 19.2083 25 19.5C25 19.7917 25.1159 20.0715 25.3222 20.2778C25.5285 20.4841 25.8083 20.6 26.1 20.6Z"
                fill="#515151"
              ></path>
              <path
                d="M26.1 16.2C28.1422 16.2 30.1007 17.0112 31.5447 18.4553C32.9887 19.8993 33.8 21.8578 33.8 23.9C33.8 24.1917 33.9159 24.4715 34.1222 24.6778C34.3285 24.8841 34.6083 25 34.9 25C35.1917 25 35.4715 24.8841 35.6778 24.6778C35.8841 24.4715 36 24.1917 36 23.9C36 21.2744 34.957 18.7563 33.1004 16.8996C31.2437 15.043 28.7256 14 26.1 14C25.8083 14 25.5285 14.1159 25.3222 14.3222C25.1159 14.5285 25 14.8083 25 15.1C25 15.3917 25.1159 15.6715 25.3222 15.8778C25.5285 16.0841 25.8083 16.2 26.1 16.2ZM35.725 29.301C35.6645 29.1244 35.56 28.9661 35.4215 28.841C35.2829 28.716 35.1148 28.6282 34.933 28.586L28.333 27.079C28.1538 27.0384 27.9674 27.0433 27.7906 27.0932C27.6138 27.1432 27.4524 27.2366 27.321 27.365C27.167 27.508 27.156 27.519 26.441 28.883C24.0685 27.7898 22.1675 25.8809 21.084 23.504C22.481 22.8 22.492 22.8 22.635 22.635C22.7634 22.5036 22.8568 22.3422 22.9068 22.1654C22.9567 21.9886 22.9616 21.8021 22.921 21.623L21.414 15.1C21.3718 14.9182 21.284 14.7501 21.159 14.6115C21.0339 14.4729 20.8756 14.3685 20.699 14.308C20.4421 14.2162 20.1768 14.1499 19.907 14.11C19.629 14.0455 19.3453 14.0087 19.06 14C17.718 14 16.431 14.5331 15.482 15.482C14.5331 16.431 14 17.718 14 19.06C14.0058 23.551 15.7924 27.8564 18.968 31.032C22.1436 34.2076 26.449 35.9942 30.94 36C31.6045 36 32.2625 35.8691 32.8764 35.6148C33.4903 35.3605 34.0481 34.9878 34.518 34.518C34.9878 34.0481 35.3605 33.4903 35.6148 32.8764C35.8691 32.2625 36 31.6045 36 30.94C36.0003 30.66 35.9783 30.3805 35.934 30.104C35.8878 29.8308 35.8178 29.5621 35.725 29.301Z"
                fill="#515151"
              ></path></svg
          ></a>
          <div class="pt-2">Call</div>
        </div>
        <div class="d-flex flex-column align-items-center w-25">
          <a
            href="https://wa.me/60134817777?text=Hi, Lim Chun siew. I would like to check the availability for this property http://localhost:3000/rent/industrial/permatang-tinggi/kawasan-industri-ringan-usahajaya/cb786. Thank you!"
            target="_blank"
            rel="noopener noreferrer"
            ><svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="50" height="50" rx="25" fill="#0F0D0D"></rect>
              <path
                d="M14.0044 36L15.4916 30.5352C14.5117 28.8553 13.9968 26.9448 14 25C14 18.9247 18.9247 14 25 14C31.0753 14 36 18.9247 36 25C36 31.0753 31.0753 36 25 36C23.0561 36.0031 21.1463 35.4887 19.467 34.5095L14.0044 36ZM21.0301 19.8388C20.8881 19.8476 20.7493 19.885 20.622 19.9488C20.5027 20.0164 20.3938 20.1008 20.2986 20.1996C20.1666 20.3239 20.0918 20.4317 20.0115 20.5362C19.605 21.0653 19.3863 21.7148 19.39 22.382C19.3922 22.921 19.533 23.4457 19.753 23.9363C20.2029 24.9285 20.9432 25.979 21.9211 26.9525C22.1565 27.1868 22.3864 27.4222 22.6339 27.6411C23.8476 28.7097 25.294 29.4803 26.8579 29.8917L27.4838 29.9874C27.6873 29.9984 27.8908 29.983 28.0954 29.9731C28.4158 29.9566 28.7286 29.8698 29.0117 29.719C29.1558 29.6448 29.2963 29.564 29.433 29.477C29.433 29.477 29.4803 29.4462 29.5705 29.378C29.719 29.268 29.8103 29.1899 29.9335 29.0612C30.0248 28.9666 30.104 28.8555 30.1645 28.729C30.2503 28.5497 30.3361 28.2076 30.3713 27.9227C30.3977 27.7049 30.39 27.5861 30.3867 27.5124C30.3823 27.3947 30.2844 27.2726 30.1777 27.2209L29.5375 26.9338C29.5375 26.9338 28.5805 26.5169 27.9964 26.2507C27.9348 26.2238 27.8688 26.2086 27.8017 26.2056C27.7264 26.1979 27.6504 26.2063 27.5787 26.2304C27.507 26.2545 27.4412 26.2937 27.3859 26.3453V26.3431C27.3804 26.3431 27.3067 26.4058 26.5114 27.3694C26.4658 27.4307 26.4029 27.4771 26.3308 27.5026C26.2587 27.528 26.1807 27.5314 26.1066 27.5124C26.0349 27.4932 25.9647 27.469 25.8965 27.4398C25.7601 27.3826 25.7128 27.3606 25.6193 27.3199L25.6138 27.3177C24.9845 27.0429 24.4019 26.6718 23.8868 26.2177C23.7482 26.0967 23.6195 25.9647 23.4875 25.8371C23.0547 25.4227 22.6776 24.9538 22.3655 24.4423L22.3006 24.3378C22.254 24.2676 22.2163 24.1918 22.1884 24.1123C22.1466 23.9506 22.2555 23.8208 22.2555 23.8208C22.2555 23.8208 22.5228 23.5282 22.6471 23.3698C22.7506 23.2381 22.8472 23.1012 22.9364 22.9595C23.0662 22.7505 23.1069 22.536 23.0387 22.3699C22.7307 21.6175 22.4117 20.8684 22.0839 20.1248C22.019 19.9774 21.8265 19.8718 21.6516 19.8509C21.5922 19.8443 21.5328 19.8377 21.4734 19.8333C21.3257 19.826 21.1777 19.8274 21.0301 19.8377V19.8388Z"
                fill="#515151"
              ></path></svg
          ></a>
          <div class="pt-2">Whatsapp</div>
        </div>
      </div>
      <a href="/"><div class="agent-profile-btn">Back to home page</div></a>
    </div>
  </modal>
</template>

<script>
export default {
  name: "prop-marketer",
  props: ["prop_id", "prop_name", "marketer", "ltype", "auth_token"],
  // data() {
  //   return {
  //     preMessage: 'Hi, ' + this.marketer.name + '. I would like to check the availability for '+ this.prop_name +'. Please call me back, Thank you!',
  //   }
  // },
  mounted() {
    this.$modal.show("outdated-listing");
  },
};
</script>

<style scoped>
.messagebox-close-btn {
  border: none;
  background: none;
  margin-right: 20px;
  padding-top: 15px;
  color: var(--p4redsurface1, #d80000);
  font-weight: 600;
}
.outdated-modal {
    width: 400px;
}
</style>